var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Vue, Prop } from 'vue-property-decorator';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { GroupSubject } from '@/models/GroupSubject';
import { Subject } from '@/models/Subject';
import { Group } from '@/models/Group';
import { UserSubjectSummary } from '@/models/UserSubjectSummary';
import { sortByKey } from '@/support/Object';
let SubjectStatusCount = class SubjectStatusCount extends Vue {
    constructor() {
        super(...arguments);
        this.statuses = [];
        this.totalStudents = 0;
        this.isLoading = true;
        this.loadFailed = false;
        this.showSummary = false;
    }
    async showSubjectSummary() {
        this.showSummary = true;
        this.totalStudents = this.getStudentCountFromGroup();
        await this.fetchUserSubjects();
    }
    displaySummary() {
        this.showSummary = true;
    }
    async fetchUserSubjects() {
        if (this.group) {
            this.isLoading = true;
            this.loadFailed = false;
            const filter = {};
            if (this.topic) {
                filter.topic = this.topic.id;
            }
            // if (this.selectedPeriods) {
            //   filter['periods'] = this.selectedPeriods;
            // }
            if (this.group) {
                filter.groups = [this.group.id];
            }
            await new UserSubjectSummary()
                .include(['parent', 'level', 'period'])
                .filter(filter)
                .load()
                .then((response) => {
                this.handleUserSubjectSummary(response);
            })
                .catch((error) => {
                this.isLoading = false;
                this.loadFailed = true;
            });
        }
        else {
            this.isLoading = false;
        }
    }
    handleUserSubjectSummary(response) {
        if (response.data.data) {
            this.statuses = this.$set(this, 'statuses', new GroupSubject().dataToModel({}, 'GroupSubject', response.data.data));
        }
        if (response.data.meta.subjects) {
            this.$set(this, 'subjects', new Subject().dataToModel({}, 'Subject', response.data.meta.subjects.sort(sortByKey('name'))));
        }
        this.isLoading = false;
    }
    getSubjectStatusCount(subject) {
        const totals = {
            highlighted: 0,
            busy: 0,
            old: 0,
            inactive: this.totalStudents,
            closed: 0,
            finished: 0,
            future: 0,
        };
        this.statuses.forEach((userSubject, index) => {
            if (userSubject.subject !== subject.subject) {
                return;
            }
            if (totals[userSubject.status || ''] !== undefined) {
                totals.inactive -= 1;
                totals[userSubject.status] += 1;
            }
        });
        return totals;
    }
    getStudentCountFromGroup() {
        if (!this.group) {
            return 0;
        }
        if (!this.group.users) {
            return 0;
        }
        const groupUsers = this.group.users;
        const students = groupUsers.filter((user) => {
            return !!user.roles && !!user.roles.find((role) => {
                return role.id === 'student';
            });
        });
        return students.length;
    }
};
__decorate([
    Prop({ default: [] }),
    __metadata("design:type", typeof (_a = typeof GroupSubject !== "undefined" && GroupSubject) === "function" ? _a : Object)
], SubjectStatusCount.prototype, "subject", void 0);
__decorate([
    Prop({ default: [] }),
    __metadata("design:type", typeof (_b = typeof Subject !== "undefined" && Subject) === "function" ? _b : Object)
], SubjectStatusCount.prototype, "topic", void 0);
__decorate([
    Prop({ default: [] }),
    __metadata("design:type", typeof (_c = typeof Group !== "undefined" && Group) === "function" ? _c : Object)
], SubjectStatusCount.prototype, "group", void 0);
SubjectStatusCount = __decorate([
    Component({
        components: {
            LoaderCard,
        },
    })
], SubjectStatusCount);
export default SubjectStatusCount;
